<template>

    <div class="textarea-wrapper" :class="{ active : isActive }">
        <span class="placeholder">{{ placeholder }}</span>
        <textarea name="text"
            maxlength="270"
            :value="value"
            @focus="focus"
            @blur="blur"
            @input="handleInput"
            @keyup="keyUp"
            ref="area"
        >
        </textarea>
        <textarea name="textcopy" class="h" ref="harea"
            maxlength="270"
        >
        </textarea>
    </div>

</template>

<script>

    export default {

        name: 'TextareaWrapper',

        props: {
            value: {
                type: String,
            },
            maxChars: {
                type: Number,
                default: null
            },
            placeholder: String
        },

        data() {
            return {
                isFocused: false,
                vValue: null,
                maxLines: 8,
                currentLines: 0
            }
        },

        computed: {

            isActive() {
                return this.isFocused || this.vValue
            }
        },

        mounted() {
            this.vValue = this.value
        },

        methods: {

            getComputed(el,prop){
                if(!el) return
                return parseInt(window.getComputedStyle(el, null).getPropertyValue(prop))
            },

            focus() {
                this.isFocused = true
            },

            blur() {
                if (!this.vValue) this.isFocused = false
            },

            handleInput(e) {

                this.vValue = e.target.value

                this.$refs.harea.value = this.vValue
                let lh = this.getComputed(this.$refs.harea,'line-height')
                this.currentLines = Math.ceil(this.$refs.harea.scrollHeight / parseInt(lh));
                // console.log(this.currentLines)
                // console.log(this.maxLines)

                if(this.currentLines > this.maxLines)
                    e.target.value = this.vValue.substring(0, this.vValue.length - 1);

                this.$emit("input", e.target.value)

            },

            keyUp(e) {

                // console.log('keyup')
                // this.$emit("input", this.vValue)

                // if(this.currentLines > this.maxLines){
                //     e.preventDefault();
                //     return false;
                // }

                // if(this.currentLines > this.maxLines){
                //     console.log('like hello')
                //     this.vValue = this.vValue.substring(0, this.vValue.length - 1);
                // }

            }
        }
    }

</script>